import type { ApiPanel } from './resolveApiPanel';

export type ApiPanelCapabilities = {
  /** GET/POST allergy_dislikes + allergy_dislike_categories (Foodna only in schema capture). */
  combined_allergy_api: boolean;
  /** allergies/dislikes return nested categories tree. */
  categorized_legacy_preferences: boolean;
  /** allergies/dislikes return flat lists under data.allergies / data.dislikes. */
  flat_legacy_preferences: boolean;
  /** menu_builders data may include complimentary_meals. */
  menu_complimentary_meals: boolean;
};

export function resolveApiPanelCapabilities(panel: ApiPanel): ApiPanelCapabilities {
  if (panel === 'foodna') {
    return {
      combined_allergy_api: true,
      categorized_legacy_preferences: true,
      flat_legacy_preferences: false,
      menu_complimentary_meals: true,
    };
  }
  return {
    combined_allergy_api: false,
    categorized_legacy_preferences: false,
    flat_legacy_preferences: true,
    menu_complimentary_meals: false,
  };
}
